import React, {
  useEffect,
  useContext,
  useState,
  useRef,
} from "react";
import { InputContainer } from "uikit-react";
import classnames from "classnames";

import { AppContexts } from "../../providers";
import { Form, FormRow, FormInputWrapper } from "../../ui";
import UIkit from "uikit";

const MacroAddImportField = ({ macro }) => {
  const { set, get, settings } = useContext(
    AppContexts.SettingsContext,
  );

  const { pmsFields, getPmsFields, loading, isNew } = useContext(
    AppContexts.UtilContext,
  );

  const [customMacros, setCustomMacros] = useState([]);
  const [newMacro, setNewMacro] = useState(null);
  const [error, setError] = useState({});
  const offCanvasRef = useRef(null);

  const checkDuplicates = (m) => {
    let customMacros = [...settings.custom_macros];
    if (macro) {
      customMacros = customMacros.filter((cm) => cm.id !== macro.id);
    }
    if (customMacros?.find((cm) => cm.field === m.field)) {
      return 'field';
    } else if (customMacros?.find((cm) => cm.macro === m.macro)) {
      return 'macro'
    } else {
      return null
    }
  }

  useEffect(() => {
    if (!pmsFields) {
      getPmsFields();
    }
    get(["custom_macros"]);
  }, []);

  useEffect(() => {
    if (macro) {
      setNewMacro({
        category: macro?.category,
        field: macro?.field,
        macro: macro?.macro
      });
    } else {
      setNewMacro(null)
    }
  }, [macro])

  useEffect(() => {
    if (!!settings.custom_macros) {
      setCustomMacros(settings.custom_macros || []);
    }
  }, [settings]);

  const selectMacroField = (e) => {
    var t = e.target,
      v = t.value,
      d = t.options[t.selectedIndex].innerHTML,
      c = t.options[t.selectedIndex].parentNode.label,
      n = newMacro?.name || "";

    if (!n) {
      n = `[${d
        .toLowerCase()
        .replace("_", " ")
        .replace(/\b[a-z](?=[a-z]{2})/g, (letter) => letter.toUpperCase())
        .replace(/[\W_]+/g, "")}]`;
    }

    setNewMacro(prev => ({
      ...prev,
      category: c,
      field: v,
      macro: n,
    }));
  };

  const updateMacroName = (cb, obj, e) => {
    var t = e.target,
      n = `[${t.value
        .replace(/\b[a-z](?=[a-z]{2})/g, (letter) => letter.toUpperCase())
        .replace(/[\W_]+/g, "")}]`;

    cb({ ...obj, macro: n });

    var caretPos = t.selectionStart,
      textLength = t.value.length;

    if (caretPos === 1) {
      caretPos++;
    } else if (caretPos === textLength) {
      caretPos--;
    }

    t.setSelectionRange(caretPos, caretPos);
  };

  const addMacro = async () => {
    if (!newMacro?.macro) {
      setError({ macro: { message: 'This is required.' }});
    } else {
      let newMacros = [...settings.custom_macros];
      const duplicatedField = checkDuplicates(newMacro);
      if (duplicatedField === 'field') {
        setError({ field: { message: 'Macro already exists' }});
      } else if (duplicatedField === 'macro') {
        setError({ macro: { message: 'Macro already exists' }});
      } else {
        setError({});
        if (macro) {
          let idx = newMacros.findIndex(
            (nm) => nm.id.toString() === macro.id.toString(),
          );
          newMacros[idx] = { ...macro, ...newMacro };
        } else {
          newMacros.push(newMacro);
        }
        await set(["custom_macros"], {
          custom_macros: newMacros,
        }).then(async (res) => {
          await get(["custom_macros"]);
          UIkit.offcanvas(offCanvasRef.current).hide();
          setNewMacro(null);
        });
        setNewMacro(null);
      }
    }
  };

  return (
    <div
      id="add-import-field-modal"
      ref={offCanvasRef}
      className="uk-modal-full hms-modals uk-modal uk-open"
      uk-offcanvas="flip: true; overlay: true"
    >
      <div className="uk-offcanvas-bar">
        <div className="hms-modals-main">
          <button
            className="uk-offcanvas-close uk-close-large"
            type="button"
            uk-close="true"
          />
          <div className="uk-modal-header">
            <h2 className="uk-modal-title">
              {!macro ? "Add a" : "Update"} Import Field
            </h2>
          </div>
          <div className="uk-modal-body uk-flex">
            <Form
              className="uk-grid-small"
              uk-grid="true"
            >
              <p>Choose a field to import from your rental software. You can use this macro in scheduled messages and digital guestbooks.</p>

              <FormRow>
                <div uk-form-custom="target: > * > span:first-child">
                  <div className="uk-width-1-1">
                    <div className="uk-form-label">
                      Select a Field
                      {loading ? <div data-uk-spinner="ratio: 0.5;"></div> : ""}
                    </div>
                    <div className="uk-form-controls w-100">
                      <div uk-form-custom="target: > * > span:first-child">
                        <select onChange={selectMacroField} disabled={loading}>
                          <option value="">Select an API Field</option>
                          {Object.keys(pmsFields || {}).map((groupName) => {
                            let fields = pmsFields[groupName];
                            return (
                              <optgroup label={groupName} key={groupName}>
                                {Object.keys(fields).map((fieldKey, index) => {
                                  if (
                                    !!customMacros.find(
                                      (macros) =>
                                        macros.field.toString() ===
                                        fieldKey.toString(),
                                    )
                                  ) {
                                    return (
                                      <React.Fragment
                                        key={`fragment_${index}`}
                                      ></React.Fragment>
                                    );
                                  } else {
                                    return (
                                      <option
                                        key={`pmsField_${index}`}
                                        value={fieldKey}
                                      >
                                        {fields[fieldKey].toString()}
                                      </option>
                                    );
                                  }
                                })}
                              </optgroup>
                            );
                          })}
                        </select>
                        <button
                          className="uk-button uk-button-default"
                          type="button"
                          tabIndex="-1"
                        >
                          <span>
                            {!newMacro || !newMacro.field || !newMacro.category
                              ? "Select an API Field"
                              : Object.keys(pmsFields?.[newMacro.category] || {})?.find(
                                  (item) => item === newMacro.field,
                                )}
                          </span>
                          <span
                            uk-icon="icon: chevron-down"
                            className="hms-align-right"
                          ></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </FormRow>

              <FormRow>
                <FormInputWrapper label="Macro*" size="two">
                  <InputContainer>
                    <input
                      className={classnames("uk-input", { error: error?.macro })}
                      type="text"
                      value={newMacro?.macro || ""}
                      onChange={(e) => {
                        updateMacroName(setNewMacro, newMacro, e);
                      }}
                    />
                  </InputContainer>
                  <div className="uk-label-danger">
                    {error.macro?.message || ''}
                  </div>
                </FormInputWrapper>
              </FormRow>

              <div>
                <button className="uk-button hms-btn hms-red-btn" type="button" onClick={addMacro}>
                  Add
                </button>
                <button
                  className="uk-button hms-btn uk-offcanvas-close"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MacroAddImportField;
